import { ArrowBack } from '@mui/icons-material';
import { Button } from "react-admin";
import { Link, useParams } from "react-router-dom";

export const BackToSkidButton = () => {
    const { id, gameId } = useParams();

    return (
        <Button
            component={Link}
            to={`/events/${id}/games/${gameId}/show`}
            label="Back to game"
            startIcon={<ArrowBack />}
        />
    );
};